import { BrowserRouter } from "react-router-dom";
import { FirebaseContextProvider } from "./components/Firebase/FirebaseContext";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import axios from "axios";
import { Provider } from "react-redux";
import store from "./redux/store";

// axios.defaults.baseURL = "http://127.0.0.1";

axios.defaults.baseURL = process.env.REACT_APP_AXIOS_BASE_URL;
// import reportWebVitals from './reportWebVitals';
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <FirebaseContextProvider>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </FirebaseContextProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
